import { Project } from "@brg/api";
import { FC, useMemo } from "react";
import { ProjectStudentText, StudentProjectContainer } from "../styles";
import { useTranslation } from "react-i18next";

export const StudentProjectBlock: FC<{ project: Project}> = ({ project }) => {
    const { t, i18n: { language}} = useTranslation();
    const hasVsTags = useMemo(() => {
        return project?.tagsID?.find((id) => {
            return ['3h8ecj38fk554a5j439bm4l4ch27dh3g', 'b85dd5a16fcd41cf87e292d5733d660f', 'f9321d1337744e44831048435055ae54']?.includes(id)
        })
    } , [])

    const hasRoles = useMemo(() => {
        return project?.author?.globalTypes?.includes('hsealumni') ||
            project?.author?.globalTypes?.includes('Student') || 
            project?.author?.globalTypes?.includes("Employee") ||
            project?.author?.globalTypes?.includes("Cooperator")
    } , [project])

    const text = useMemo(() => {
        return <ProjectStudentText>{t('projectStudent.text')}</ProjectStudentText>
    } , [language, t])

    if (!hasVsTags || !hasRoles) {
        return null
    }
    
    return (
        <StudentProjectContainer>
            {text}
        </StudentProjectContainer>
    )
}import { Project } from "@brg/api";
import { FC, useMemo } from "react";
import { ProjectStudentText, StudentProjectContainer } from "../styles";
import { useTranslation } from "react-i18next";

export const StudentProjectBlock: FC<{ project: Project}> = ({ project }) => {
    const { t, i18n: { language}} = useTranslation();
    const hasVsTags = useMemo(() => {
        return project?.tagsID?.find((id) => {
            return ['3h8ecj38fk554a5j439bm4l4ch27dh3g', 'b85dd5a16fcd41cf87e292d5733d660f', 'f9321d1337744e44831048435055ae54']?.includes(id)
        })
    } , [])

    const hasRoles = useMemo(() => {
        return project?.author?.globalTypes?.includes('hsealumni') ||
            project?.author?.globalTypes?.includes('Student') || 
            project?.author?.globalTypes?.includes("Employee") ||
            project?.author?.globalTypes?.includes("Cooperator")
    } , [project])

    const text = useMemo(() => {
        return <ProjectStudentText>{t('projectStudent.text')}</ProjectStudentText>
    } , [language, t])

    if (!hasVsTags || !hasRoles) {
        return null
    }
    
    return (
        <StudentProjectContainer>
            {text}
        </StudentProjectContainer>
    )
}